import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { setErrorState } from "../../../redux/error_banner/actions";

function ErrorBanner() {
    const dispatch = useDispatch();

    const { hasError, errorText } = useSelector(
        (state) => state.ErrorBannerReducer
    );

    function dismissError() {
        dispatch(setErrorState(false, "Close Error Banner", null, null));
    }

    if (!hasError) {
        return null;
    }

    return (
        <div className="absolute top-0 left-0 h-6.5 w-full bg-[#dddddd]">
            <div id="error-banner-text" className="ml-5 text-[#b61e1e]">
                ERROR: {errorText}
            </div>
            <button
                id="error-banner-close-btn"
                className="click-outside-ignore absolute top-0 right-0 mr-5 border-none bg-none p-0 text-[#000000]"
                onClick={dismissError}
            >
                X
            </button>
        </div>
    );
}

ErrorBanner.propTypes = {
    hasError: PropTypes.bool,
    errorText: PropTypes.string,
    setErrorState: PropTypes.func,
};

export default ErrorBanner;
